module.exports = __webpack_public_path__ + "e8222954940cb40d6e8c4a05a0a3e7ff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/school.png
// module id = 1676
// module chunks = 0